import script from "./mp3-upload.vue?vue&type=script&setup=true&lang=ts"
export * from "./mp3-upload.vue?vue&type=script&setup=true&lang=ts"

import "./mp3-upload.vue?vue&type=style&index=0&id=596fbaed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-596fbaed"]])

export default __exports__